import { IStoryItem, StoryType } from 'interfaces/addStory.interface';
import { ChangeEvent, FC, useState } from 'react';
import {
  MentionInput,
  MenuCont,
  MenuItem,
  MenuItemsCont,
  NameText,
  UserImg,
} from './StoryMentionMenu.styles';

interface IStoryMentionMenu {
  hideUI: () => void;
  addToStoryBoard?: (data: IStoryItem) => void;
}

const StoryMentionMenu: FC<IStoryMentionMenu> = ({
  addToStoryBoard,
  hideUI,
}) => {
  // const mentionImg = require('assets/icons/quote-left-solid.svg');
  const user0Img = require('assets/user0.png');
  const user1Img = require('assets/user1.png');
  // const stickerImg2 = require('assets/appicon.png');

  const [showMentionUsers, setShowMentionUsers] = useState<boolean>(false);
  const [, setUsername] = useState<string>('');

  const localAddToStoryBoard = (username: string) => {
    if (addToStoryBoard) {
      const data: IStoryItem = {
        id: 0,
        position: {
          X: 50,
          Y: 50,
        },
        size: {
          X: 100,
          Y: 100,
        },
        type: StoryType.Mention,
        text: '@' + username,
      };
      addToStoryBoard(data);
      hideUI();
    }
  };

  const handleMentionChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 0) {
      setShowMentionUsers(true);
    } else {
      setShowMentionUsers(false);
    }
    setUsername(`@${e.target.value}`);
  };

  return (
    <>
      <MentionInput
        type="text"
        onChange={handleMentionChange}
        autoFocus={true}
      />
      <MenuCont>
        {showMentionUsers && (
          <MenuItemsCont
            container
            className="scrollbar-hidden"
            style={{ margin: '0' }}
          >
            <MenuItem item xs={4}>
              <UserImg
                src={user0Img}
                onClick={() => localAddToStoryBoard('JohnsonAk')}
              />
              <NameText>JohnsonAk</NameText>
            </MenuItem>
            <MenuItem item xs={4}>
              <UserImg
                src={user1Img}
                onClick={() => localAddToStoryBoard('JellyKa')}
              />
              <NameText>JellyKa</NameText>
            </MenuItem>
            <MenuItem item xs={4}>
              <UserImg
                src={user0Img}
                onClick={() => localAddToStoryBoard('JohnsonAk')}
              />
              <NameText>JohnsonAk</NameText>
            </MenuItem>
            <MenuItem item xs={4}>
              <UserImg
                src={user1Img}
                onClick={() => localAddToStoryBoard('JellyKa')}
              />
              <NameText>JellyKa</NameText>
            </MenuItem>
            <MenuItem item xs={4}>
              <UserImg
                src={user0Img}
                onClick={() => localAddToStoryBoard('JohnsonAk')}
              />
              <NameText>JohnsonAk</NameText>
            </MenuItem>
          </MenuItemsCont>
        )}
      </MenuCont>
    </>
  );
};

export default StoryMentionMenu;
